export const countryList = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Federated States of Micronesia',
  'Fiji Islands',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'North Korea',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Other',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'United States Virgin Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Yugoslavia',
  'Zambia',
  'Zimbabwe',
]

export const allowedBusinessCountries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Federated States of Micronesia',
  'Fiji Islands',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Other',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'United States Virgin Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Yugoslavia',
  'Zambia',
  'Zimbabwe',
]

export const twoLetterCountryCodeMap = {
  afghanistan: 'AF',
  albania: 'AL',
  algeria: 'DZ',
  'american samoa': 'AS',
  andorra: 'AD',
  angola: 'AO',
  anguilla: 'AI',
  antarctica: 'AQ',
  'antigua and barbuda': 'AG',
  argentina: 'AR',
  armenia: 'AM',
  aruba: 'AW',
  australia: 'AU',
  austria: 'AT',
  azerbaijan: 'AZ',
  bahamas: 'BS',
  bahrain: 'BH',
  bangladesh: 'BD',
  barbados: 'BB',
  belarus: 'BY',
  belgium: 'BE',
  belize: 'BZ',
  benin: 'BJ',
  bermuda: 'BM',
  bhutan: 'BT',
  'bolivia, plurinational state of': 'BO',
  'bonaire, sint eustatius and saba': 'BQ',
  'bosnia and herzegovina': 'BA',
  botswana: 'BW',
  'bouvet island': 'BV',
  brazil: 'BR',
  'british indian ocean territory': 'IO',
  'brunei darussalam': 'BN',
  bulgaria: 'BG',
  'burkina faso': 'BF',
  burundi: 'BI',
  cambodia: 'KH',
  cameroon: 'CM',
  canada: 'CA',
  'cape verde': 'CV',
  'cayman islands': 'KY',
  'central african republic': 'CF',
  chad: 'TD',
  chile: 'CL',
  china: 'CN',
  'christmas island': 'CX',
  'cocos (keeling) islands': 'CC',
  colombia: 'CO',
  comoros: 'KM',
  congo: 'CG',
  'congo, the democratic republic of the': 'CD',
  'cook islands': 'CK',
  'costa rica': 'CR',
  croatia: 'HR',
  cuba: 'CU',
  curaçao: 'CW',
  cyprus: 'CY',
  'czech republic': 'CZ',
  "côte d'ivoire": 'CI',
  denmark: 'DK',
  djibouti: 'DJ',
  dominica: 'DM',
  'dominican republic': 'DO',
  ecuador: 'EC',
  egypt: 'EG',
  'el salvador': 'SV',
  'equatorial guinea': 'GQ',
  eritrea: 'ER',
  estonia: 'EE',
  ethiopia: 'ET',
  'falkland islands (malvinas': 'FK',
  'faroe islands': 'FO',
  fiji: 'FJ',
  finland: 'FI',
  france: 'FR',
  'french guiana': 'GF',
  'french polynesia': 'PF',
  'french southern territories': 'TF',
  gabon: 'GA',
  gambia: 'GM',
  georgia: 'GE',
  germany: 'DE',
  ghana: 'GH',
  gibraltar: 'GI',
  greece: 'GR',
  greenland: 'GL',
  grenada: 'GD',
  guadeloupe: 'GP',
  guam: 'GU',
  guatemala: 'GT',
  guernsey: 'GG',
  guinea: 'GN',
  'guinea-bissau': 'GW',
  guyana: 'GY',
  haiti: 'HT',
  'heard island and mcdonald islands': 'HM',
  'holy see (vatican city state': 'VA',
  honduras: 'HN',
  'hong kong': 'HK',
  hungary: 'HU',
  iceland: 'IS',
  india: 'IN',
  indonesia: 'ID',
  'iran, islamic republic of': 'IR',
  iraq: 'IQ',
  ireland: 'IE',
  'isle of man': 'IM',
  israel: 'IL',
  italy: 'IT',
  jamaica: 'JM',
  japan: 'JP',
  jersey: 'JE',
  jordan: 'JO',
  kazakhstan: 'KZ',
  kenya: 'KE',
  kiribati: 'KI',
  "korea, democratic people's republic of": 'KP',
  'korea, republic of': 'KR',
  kuwait: 'KW',
  kyrgyzstan: 'KG',
  "lao people's democratic republic": 'LA',
  latvia: 'LV',
  lebanon: 'LB',
  lesotho: 'LS',
  liberia: 'LR',
  libya: 'LY',
  liechtenstein: 'LI',
  lithuania: 'LT',
  luxembourg: 'LU',
  macao: 'MO',
  'macedonia, the former yugoslav republic of': 'MK',
  madagascar: 'MG',
  malawi: 'MW',
  malaysia: 'MY',
  maldives: 'MV',
  mali: 'ML',
  malta: 'MT',
  'marshall islands': 'MH',
  martinique: 'MQ',
  mauritania: 'MR',
  mauritius: 'MU',
  mayotte: 'YT',
  mexico: 'MX',
  'micronesia, federated states of': 'FM',
  'moldova, republic of': 'MD',
  monaco: 'MC',
  mongolia: 'MN',
  montenegro: 'ME',
  montserrat: 'MS',
  morocco: 'MA',
  mozambique: 'MZ',
  myanmar: 'MM',
  namibia: 'NA',
  nauru: 'NR',
  nepal: 'NP',
  netherlands: 'NL',
  'new caledonia': 'NC',
  'new zealand': 'NZ',
  nicaragua: 'NI',
  niger: 'NE',
  nigeria: 'NG',
  niue: 'NU',
  'norfolk island': 'NF',
  'northern mariana islands': 'MP',
  norway: 'NO',
  oman: 'OM',
  pakistan: 'PK',
  palau: 'PW',
  'palestinian territory, occupied': 'PS',
  panama: 'PA',
  'papua new guinea': 'PG',
  paraguay: 'PY',
  peru: 'PE',
  philippines: 'PH',
  pitcairn: 'PN',
  poland: 'PL',
  portugal: 'PT',
  'puerto rico': 'PR',
  qatar: 'QA',
  romania: 'RO',
  'russian federation': 'RU',
  rwanda: 'RW',
  réunion: 'RE',
  'saint barthélemy': 'BL',
  'saint helena, ascension and tristan da cunha': 'SH',
  'saint kitts and nevis': 'KN',
  'saint lucia': 'LC',
  'saint martin (french part': 'MF',
  'saint pierre and miquelon': 'PM',
  'saint vincent and the grenadines': 'VC',
  samoa: 'WS',
  'san marino': 'SM',
  'sao tome and principe': 'ST',
  'saudi arabia': 'SA',
  senegal: 'SN',
  serbia: 'RS',
  seychelles: 'SC',
  'sierra leone': 'SL',
  singapore: 'SG',
  'sint maarten (dutch part': 'SX',
  slovakia: 'SK',
  slovenia: 'SI',
  'solomon islands': 'SB',
  somalia: 'SO',
  'south africa': 'ZA',
  'south georgia and the south sandwich islands': 'GS',
  'south sudan': 'SS',
  spain: 'ES',
  'sri lanka': 'LK',
  sudan: 'SD',
  suriname: 'SR',
  'svalbard and jan mayen': 'SJ',
  swaziland: 'SZ',
  sweden: 'SE',
  switzerland: 'CH',
  'syrian arab republic': 'SY',
  'taiwan, province of china': 'TW',
  tajikistan: 'TJ',
  'tanzania, united republic of': 'TZ',
  thailand: 'TH',
  'timor-leste': 'TL',
  togo: 'TG',
  tokelau: 'TK',
  tonga: 'TO',
  'trinidad and tobago': 'TT',
  tunisia: 'TN',
  turkey: 'TR',
  turkmenistan: 'TM',
  'turks and caicos islands': 'TC',
  tuvalu: 'TV',
  uganda: 'UG',
  ukraine: 'UA',
  'united arab emirates': 'AE',
  'united kingdom': 'GB',
  'united states': 'US',
  'united states minor outlying islands': 'UM',
  uruguay: 'UY',
  uzbekistan: 'UZ',
  vanuatu: 'VU',
  'venezuela, bolivarian republic of': 'VE',
  'viet nam': 'VN',
  'virgin islands, british': 'VG',
  'virgin islands, u.s': 'VI',
  'wallis and futuna': 'WF',
  'western sahara': 'EH',
  yemen: 'YE',
  zambia: 'ZM',
  zimbabwe: 'ZW',
  'åland islands': 'AX',
}

// ISO 3166-1 alpha-2
export const countryCodes = [
  {
    value: 'AD',
    label: 'ANDORRA',
  },
  {
    value: 'AE',
    label: 'UNITED ARAB EMIRATES',
  },
  {
    value: 'AF',
    label: 'AFGHANISTAN',
  },
  {
    value: 'AG',
    label: 'ANTIGUA AND BARBUDA',
  },
  {
    value: 'AI',
    label: 'ANGUILLA',
  },
  {
    value: 'AL',
    label: 'ALBANIA',
  },
  {
    value: 'AM',
    label: 'ARMENIA',
  },
  {
    value: 'AN',
    label: 'NETHERLANDS ANTILLES',
  },
  {
    value: 'AO',
    label: 'ANGOLA',
  },
  {
    value: 'AQ',
    label: 'ANTARCTICA',
  },
  {
    value: 'AR',
    label: 'ARGENTINA',
  },
  {
    value: 'AS',
    label: 'AMERICAN SAMOA',
  },
  {
    value: 'AT',
    label: 'AUSTRIA',
  },
  {
    value: 'AU',
    label: 'AUSTRALIA',
  },
  {
    value: 'AW',
    label: 'ARUBA',
  },
  {
    value: 'AZ',
    label: 'AZERBAIJAN',
  },
  {
    value: 'BA',
    label: 'BOSNIA AND HERZEGOVINA',
  },
  {
    value: 'BB',
    label: 'BARBADOS',
  },
  {
    value: 'BD',
    label: 'BANGLADESH',
  },
  {
    value: 'BE',
    label: 'BELGIUM',
  },
  {
    value: 'BF',
    label: 'BURKINA FASO',
  },
  {
    value: 'BG',
    label: 'BULGARIA',
  },
  {
    value: 'BH',
    label: 'BAHRAIN',
  },
  {
    value: 'BI',
    label: 'BURUNDI',
  },
  {
    value: 'BJ',
    label: 'BENIN',
  },
  {
    value: 'BL',
    label: 'SAINT BARTHELEMY',
  },
  {
    value: 'BM',
    label: 'BERMUDA',
  },
  {
    value: 'BN',
    label: 'BRUNEI DARUSSALAM',
  },
  {
    value: 'BO',
    label: 'BOLIVIA',
  },
  {
    value: 'BR',
    label: 'BRAZIL',
  },
  {
    value: 'BS',
    label: 'BAHAMAS',
  },
  {
    value: 'BT',
    label: 'BHUTAN',
  },
  {
    value: 'BW',
    label: 'BOTSWANA',
  },
  {
    value: 'BY',
    label: 'BELARUS',
  },
  {
    value: 'BZ',
    label: 'BELIZE',
  },
  {
    value: 'CA',
    label: 'CANADA',
  },
  {
    value: 'CC',
    label: 'COCOS (KEELING) ISLANDS',
  },
  {
    value: 'CD',
    label: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE',
  },
  {
    value: 'CF',
    label: 'CENTRAL AFRICAN REPUBLIC',
  },
  {
    value: 'CG',
    label: 'CONGO',
  },
  {
    value: 'CH',
    label: 'SWITZERLAND',
  },
  {
    value: 'CI',
    label: 'COTE D IVOIRE',
  },
  {
    value: 'CK',
    label: 'COOK ISLANDS',
  },
  {
    value: 'CL',
    label: 'CHILE',
  },
  {
    value: 'CM',
    label: 'CAMEROON',
  },
  {
    value: 'CN',
    label: 'CHINA',
  },
  {
    value: 'CO',
    label: 'COLOMBIA',
  },
  {
    value: 'CR',
    label: 'COSTA RICA',
  },
  {
    value: 'CU',
    label: 'CUBA',
  },
  {
    value: 'CV',
    label: 'CAPE VERDE',
  },
  {
    value: 'CX',
    label: 'CHRISTMAS ISLAND',
  },
  {
    value: 'CY',
    label: 'CYPRUS',
  },
  {
    value: 'CZ',
    label: 'CZECH REPUBLIC',
  },
  {
    value: 'DE',
    label: 'GERMANY',
  },
  {
    value: 'DJ',
    label: 'DJIBOUTI',
  },
  {
    value: 'DK',
    label: 'DENMARK',
  },
  {
    value: 'DM',
    label: 'DOMINICA',
  },
  {
    value: 'DO',
    label: 'DOMINICAN REPUBLIC',
  },
  {
    value: 'DZ',
    label: 'ALGERIA',
  },
  {
    value: 'EC',
    label: 'ECUADOR',
  },
  {
    value: 'EE',
    label: 'ESTONIA',
  },
  {
    value: 'EG',
    label: 'EGYPT',
  },
  {
    value: 'ER',
    label: 'ERITREA',
  },
  {
    value: 'ES',
    label: 'SPAIN',
  },
  {
    value: 'ET',
    label: 'ETHIOPIA',
  },
  {
    value: 'FI',
    label: 'FINLAND',
  },
  {
    value: 'FJ',
    label: 'FIJI',
  },
  {
    value: 'FK',
    label: 'FALKLAND ISLANDS (MALVINAS)',
  },
  {
    value: 'FM',
    label: 'MICRONESIA, FEDERATED STATES OF',
  },
  {
    value: 'FO',
    label: 'FAROE ISLANDS',
  },
  {
    value: 'FR',
    label: 'FRANCE',
  },
  {
    value: 'GA',
    label: 'GABON',
  },
  {
    value: 'GB',
    label: 'UNITED KINGDOM',
  },
  {
    value: 'GD',
    label: 'GRENADA',
  },
  {
    value: 'GE',
    label: 'GEORGIA',
  },
  {
    value: 'GH',
    label: 'GHANA',
  },
  {
    value: 'GI',
    label: 'GIBRALTAR',
  },
  {
    value: 'GL',
    label: 'GREENLAND',
  },
  {
    value: 'GM',
    label: 'GAMBIA',
  },
  {
    value: 'GN',
    label: 'GUINEA',
  },
  {
    value: 'GQ',
    label: 'EQUATORIAL GUINEA',
  },
  {
    value: 'GR',
    label: 'GREECE',
  },
  {
    value: 'GT',
    label: 'GUATEMALA',
  },
  {
    value: 'GU',
    label: 'GUAM',
  },
  {
    value: 'GW',
    label: 'GUINEA-BISSAU',
  },
  {
    value: 'GY',
    label: 'GUYANA',
  },
  {
    value: 'HK',
    label: 'HONG KONG',
  },
  {
    value: 'HN',
    label: 'HONDURAS',
  },
  {
    value: 'HR',
    label: 'CROATIA',
  },
  {
    value: 'HT',
    label: 'HAITI',
  },
  {
    value: 'HU',
    label: 'HUNGARY',
  },
  {
    value: 'ID',
    label: 'INDONESIA',
  },
  {
    value: 'IE',
    label: 'IRELAND',
  },
  {
    value: 'IL',
    label: 'ISRAEL',
  },
  {
    value: 'IM',
    label: 'ISLE OF MAN',
  },
  {
    value: 'IN',
    label: 'INDIA',
  },
  {
    value: 'IQ',
    label: 'IRAQ',
  },
  {
    value: 'IR',
    label: 'IRAN, ISLAMIC REPUBLIC OF',
  },
  {
    value: 'IS',
    label: 'ICELAND',
  },
  {
    value: 'IT',
    label: 'ITALY',
  },
  {
    value: 'JM',
    label: 'JAMAICA',
  },
  {
    value: 'JO',
    label: 'JORDAN',
  },
  {
    value: 'JP',
    label: 'JAPAN',
  },
  {
    value: 'KE',
    label: 'KENYA',
  },
  {
    value: 'KG',
    label: 'KYRGYZSTAN',
  },
  {
    value: 'KH',
    label: 'CAMBODIA',
  },
  {
    value: 'KI',
    label: 'KIRIBATI',
  },
  {
    value: 'KM',
    label: 'COMOROS',
  },
  {
    value: 'KN',
    label: 'SAINT KITTS AND NEVIS',
  },
  {
    value: 'KP',
    label: 'KOREA DEMOCRATIC PEOPLES REPUBLIC OF',
  },
  {
    value: 'KR',
    label: 'KOREA REPUBLIC OF',
  },
  {
    value: 'KW',
    label: 'KUWAIT',
  },
  {
    value: 'KY',
    label: 'CAYMAN ISLANDS',
  },
  {
    value: 'KZ',
    label: 'KAZAKSTAN',
  },
  {
    value: 'LA',
    label: 'LAO PEOPLES DEMOCRATIC REPUBLIC',
  },
  {
    value: 'LB',
    label: 'LEBANON',
  },
  {
    value: 'LC',
    label: 'SAINT LUCIA',
  },
  {
    value: 'LI',
    label: 'LIECHTENSTEIN',
  },
  {
    value: 'LK',
    label: 'SRI LANKA',
  },
  {
    value: 'LR',
    label: 'LIBERIA',
  },
  {
    value: 'LS',
    label: 'LESOTHO',
  },
  {
    value: 'LT',
    label: 'LITHUANIA',
  },
  {
    value: 'LU',
    label: 'LUXEMBOURG',
  },
  {
    value: 'LV',
    label: 'LATVIA',
  },
  {
    value: 'LY',
    label: 'LIBYAN ARAB JAMAHIRIYA',
  },
  {
    value: 'MA',
    label: 'MOROCCO',
  },
  {
    value: 'MC',
    label: 'MONACO',
  },
  {
    value: 'MD',
    label: 'MOLDOVA, REPUBLIC OF',
  },
  {
    value: 'ME',
    label: 'MONTENEGRO',
  },
  {
    value: 'MF',
    label: 'SAINT MARTIN',
  },
  {
    value: 'MG',
    label: 'MADAGASCAR',
  },
  {
    value: 'MH',
    label: 'MARSHALL ISLANDS',
  },
  {
    value: 'MK',
    label: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
  },
  {
    value: 'ML',
    label: 'MALI',
  },
  {
    value: 'MM',
    label: 'MYANMAR',
  },
  {
    value: 'MN',
    label: 'MONGOLIA',
  },
  {
    value: 'MO',
    label: 'MACAU',
  },
  {
    value: 'MP',
    label: 'NORTHERN MARIANA ISLANDS',
  },
  {
    value: 'MR',
    label: 'MAURITANIA',
  },
  {
    value: 'MS',
    label: 'MONTSERRAT',
  },
  {
    value: 'MT',
    label: 'MALTA',
  },
  {
    value: 'MU',
    label: 'MAURITIUS',
  },
  {
    value: 'MV',
    label: 'MALDIVES',
  },
  {
    value: 'MW',
    label: 'MALAWI',
  },
  {
    value: 'MX',
    label: 'MEXICO',
  },
  {
    value: 'MY',
    label: 'MALAYSIA',
  },
  {
    value: 'MZ',
    label: 'MOZAMBIQUE',
  },
  {
    value: 'NA',
    label: 'NAMIBIA',
  },
  {
    value: 'NC',
    label: 'NEW CALEDONIA',
  },
  {
    value: 'NE',
    label: 'NIGER',
  },
  {
    value: 'NG',
    label: 'NIGERIA',
  },
  {
    value: 'NI',
    label: 'NICARAGUA',
  },
  {
    value: 'NL',
    label: 'NETHERLANDS',
  },
  {
    value: 'NO',
    label: 'NORWAY',
  },
  {
    value: 'NP',
    label: 'NEPAL',
  },
  {
    value: 'NR',
    label: 'NAURU',
  },
  {
    value: 'NU',
    label: 'NIUE',
  },
  {
    value: 'NZ',
    label: 'NEW ZEALAND',
  },
  {
    value: 'OM',
    label: 'OMAN',
  },
  {
    value: 'PA',
    label: 'PANAMA',
  },
  {
    value: 'PE',
    label: 'PERU',
  },
  {
    value: 'PF',
    label: 'FRENCH POLYNESIA',
  },
  {
    value: 'PG',
    label: 'PAPUA NEW GUINEA',
  },
  {
    value: 'PH',
    label: 'PHILIPPINES',
  },
  {
    value: 'PK',
    label: 'PAKISTAN',
  },
  {
    value: 'PL',
    label: 'POLAND',
  },
  {
    value: 'PM',
    label: 'SAINT PIERRE AND MIQUELON',
  },
  {
    value: 'PN',
    label: 'PITCAIRN',
  },
  {
    value: 'PR',
    label: 'PUERTO RICO',
  },
  {
    value: 'PT',
    label: 'PORTUGAL',
  },
  {
    value: 'PW',
    label: 'PALAU',
  },
  {
    value: 'PY',
    label: 'PARAGUAY',
  },
  {
    value: 'QA',
    label: 'QATAR',
  },
  {
    value: 'RO',
    label: 'ROMANIA',
  },
  {
    value: 'RS',
    label: 'SERBIA',
  },
  {
    value: 'RU',
    label: 'RUSSIAN FEDERATION',
  },
  {
    value: 'RW',
    label: 'RWANDA',
  },
  {
    value: 'SA',
    label: 'SAUDI ARABIA',
  },
  {
    value: 'SB',
    label: 'SOLOMON ISLANDS',
  },
  {
    value: 'SC',
    label: 'SEYCHELLES',
  },
  {
    value: 'SD',
    label: 'SUDAN',
  },
  {
    value: 'SE',
    label: 'SWEDEN',
  },
  {
    value: 'SG',
    label: 'SINGAPORE',
  },
  {
    value: 'SH',
    label: 'SAINT HELENA',
  },
  {
    value: 'SI',
    label: 'SLOVENIA',
  },
  {
    value: 'SK',
    label: 'SLOVAKIA',
  },
  {
    value: 'SL',
    label: 'SIERRA LEONE',
  },
  {
    value: 'SM',
    label: 'SAN MARINO',
  },
  {
    value: 'SN',
    label: 'SENEGAL',
  },
  {
    value: 'SO',
    label: 'SOMALIA',
  },
  {
    value: 'SR',
    label: 'SURINAME',
  },
  {
    value: 'ST',
    label: 'SAO TOME AND PRINCIPE',
  },
  {
    value: 'SV',
    label: 'EL SALVADOR',
  },
  {
    value: 'SY',
    label: 'SYRIAN ARAB REPUBLIC',
  },
  {
    value: 'SZ',
    label: 'SWAZILAND',
  },
  {
    value: 'TC',
    label: 'TURKS AND CAICOS ISLANDS',
  },
  {
    value: 'TD',
    label: 'CHAD',
  },
  {
    value: 'TG',
    label: 'TOGO',
  },
  {
    value: 'TH',
    label: 'THAILAND',
  },
  {
    value: 'TJ',
    label: 'TAJIKISTAN',
  },
  {
    value: 'TK',
    label: 'TOKELAU',
  },
  {
    value: 'TL',
    label: 'TIMOR-LESTE',
  },
  {
    value: 'TM',
    label: 'TURKMENISTAN',
  },
  {
    value: 'TN',
    label: 'TUNISIA',
  },
  {
    value: 'TO',
    label: 'TONGA',
  },
  {
    value: 'TR',
    label: 'TURKEY',
  },
  {
    value: 'TT',
    label: 'TRINIDAD AND TOBAGO',
  },
  {
    value: 'TV',
    label: 'TUVALU',
  },
  {
    value: 'TW',
    label: 'TAIWAN, PROVINCE OF CHINA',
  },
  {
    value: 'TZ',
    label: 'TANZANIA, UNITED REPUBLIC OF',
  },
  {
    value: 'UA',
    label: 'UKRAINE',
  },
  {
    value: 'UG',
    label: 'UGANDA',
  },
  {
    value: 'US',
    label: 'UNITED STATES',
  },
  {
    value: 'UY',
    label: 'URUGUAY',
  },
  {
    value: 'UZ',
    label: 'UZBEKISTAN',
  },
  {
    value: 'VA',
    label: 'HOLY SEE (VATICAN CITY STATE)',
  },
  {
    value: 'VC',
    label: 'SAINT VINCENT AND THE GRENADINES',
  },
  {
    value: 'VE',
    label: 'VENEZUELA',
  },
  {
    value: 'VG',
    label: 'VIRGIN ISLANDS, BRITISH',
  },
  {
    value: 'VI',
    label: 'VIRGIN ISLANDS, U.S.',
  },
  {
    value: 'VN',
    label: 'VIETNAM',
  },
  {
    value: 'VU',
    label: 'VANUATU',
  },
  {
    value: 'WF',
    label: 'WALLIS AND FUTUNA',
  },
  {
    value: 'WS',
    label: 'SAMOA',
  },
  {
    value: 'XK',
    label: 'KOSOVO',
  },
  {
    value: 'YE',
    label: 'YEMEN',
  },
  {
    value: 'YT',
    label: 'MAYOTTE',
  },
  {
    value: 'ZA',
    label: 'SOUTH AFRICA',
  },
  {
    value: 'ZM',
    label: 'ZAMBIA',
  },
  {
    value: 'ZW',
    label: 'ZIMBABWE',
  },
]
